var map = {
	"./bggl.png": "b3b1",
	"./erp.png": "04a6",
	"./jxgl.png": "0a05",
	"./old.png": "66a8",
	"./wx_1.png": "a649",
	"./xtgl.png": "2658"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ede";